
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agent-resources",
      function () {
        return require("private-next-pages/agent-resources/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agent-resources"])
      });
    }
  